const arloVideoModal = document.getElementById("arloVideoModal");
const arloVideoPlayer = document.getElementById("arloVideoPlayer");
const videoSource = arloVideoPlayer.querySelector("source");
const closeVideoModal = document.querySelector(".video-gallery__modal-close");
const videoElements = document.querySelectorAll(".video-gallery__video_holder");

let currentVideoIndex = 0;

videoElements.forEach((el, index) => {
  el.addEventListener("click", function () {
    const videoUrl = this.getAttribute("data-video");
    openArloVideoModal(videoUrl, index);
  });
});

function openArloVideoModal(videoUrl, index) {
  currentVideoIndex = index;
  videoSource.src = videoUrl; // Set video source to the clicked video
  arloVideoPlayer.load();
  arloVideoPlayer.play();
  arloVideoModal.style.display = "flex"; // Show the modal
}

function stopVideo() {
  arloVideoPlayer.pause();
  arloVideoPlayer.currentTime = 0;
}

function closeArloVideoModal() {
  arloVideoModal.style.display = "none";
  stopVideo();
}

closeVideoModal.onclick = function () {
  closeArloVideoModal();
};

arloVideoModal.onclick = function (event) {
  if (event.target === arloVideoModal) {
    closeArloVideoModal();
  }
};

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    closeArloVideoModal();
  }
});
